// 线上地址
// export const ONLINEURL:string = 'http://card.ntlbykj.com:3002'
// export const ONLINEURL:string = 'http://127.0.0.1:3002'
// export const ONLINEURL:string = 'http://card.ntlbykj.com:3002'
// export const ONLINEURL:string = 'http://106.14.167.206:8092'
// export const ONLINEURL:string = 'http://192.168.4.86:3002'
// export const ONLINEURL:string = 'http://106.14.167.206:8092'
// export const ONLINEURL:string = 'http://192.168.0.14:8092'
export const ONLINEURL:string = '/api'
// export const ONLINEURL:string = 'http://192.168.16.199:8092'

// 测试地址
// export const TESTURL:string = 'http://wushan.jsxywg.cn/pc'
// export const TESTURL:string = 'http://192.168.20.196:8092'
// export const TESTURL:string = 'http://192.168.1.119:8092'
export const TESTURL:string = '/api'
// export const TESTURL:string = 'http://member.ntlbykj.com:3002'



export const IMAGEURL:string = 'https://lvboyuan-card.oss-cn-shanghai.aliyuncs.com/'

// 当前的地址

export const MAINURL:string = ONLINEURL
